<div class="SLV2-main-wrapper">
    <div class="col-xl-2 col-md-3" *ngIf="selfLearnService.isFromLearn()">
        <app-sidebar-learn></app-sidebar-learn>    
    </div>
    <div class="SLV2-body-section">

        <div class="SLV2-section-wrap SLV2-page-header-area">
            <div class="row SLV2-sm-gap">
                <!-- <div class="col">
                    <div class="SLV2-header-text-button SLV2-library">
                      <img src="selflearnv2-ui/assets/img/self-learn-v2/banner-back-arrow.svg" />
                        <span>My Library</span>
                    </div>
                </div> -->
            </div>
        </div>


        <div class="SLV2-section-wrap memory-card-banner-section" *ngIf="flashCardids?.length>0">
            <div class="row SLV2-sm-gap">
                <div class="col">
                    <app-memory-banner-card></app-memory-banner-card>
                </div>
            </div>
        </div>

        <div class="SLV2-section-wrap SLV2-bookmark-slider-area">
            <div class="row SLV2-sm-gap" *ngIf="allBookMarksList?.length >0">
                <div class="col">
                    <div class="SLV2-section-head-section">
                        <h3 class="SLV2-section-heading">My Bookmarks</h3>
                        <button class="SLV2-viewall-link" (click) ="goTOBookMarks()" *ngIf="allBookMarksList?.length >=5">View all <img src="selflearnv2-ui/assets/img/self-learn-v2/right-blue-arrow.svg" /></button>
                    </div>
                </div>
            </div>
            <div class="row SLV2-sm-gap"  *ngIf="allBookMarksList?.length >0">
                <div class="col">
                    <ngb-carousel #carousel class="singleCarousel SLV2-bookmark-single-slider" [interval]="5000" [pauseOnHover]="pauseOnHover"
                        [pauseOnFocus]="pauseOnFocus">
                        <ng-container *ngFor="let item of allBookMarksList; let i = index">
                            <ng-container *ngIf="i<5">
                                <ng-template ngbSlide *ngIf="item.type == 'video' || item.type =='video_solution'">
                                    <app-bookmark-video-card class="mobile-col-view col-view"   [videoData]="item" [cardTitle]="item.name" [isFromMyLibrary]=true [isFromMyHistory]=false></app-bookmark-video-card>
                                </ng-template>
                                <ng-template ngbSlide *ngIf="item.type == 'flashcard'">
                                    <app-bookmark-topic-summery-card class="mobile-col-view col-view" *ngIf="item.type == 'flashcard'" [topicName]="item?.name" [flashcardData]="item"  [isFromMyLibrary]=true [isFromMyHistory]=false></app-bookmark-topic-summery-card>
                                </ng-template>
                                <ng-template ngbSlide *ngIf="item.type == 'memory_card'">
                                     <app-memory-thumb-card class="mobile-col-view  col-view" [memoryData]="item" [cardTitle]="item.name"  [isFromMyLibrary]=true [isFromMyHistory]=false></app-memory-thumb-card>
                                </ng-template> 
                                     <ng-template ngbSlide *ngIf="item.type == 'practice_question'">
                                    <app-questions-thumb-card class="mobile-col-view col-view"  [questionData]="item" [cardTitle]="item.name"  [isFromMyLibrary]=true [isFromMyHistory]=false></app-questions-thumb-card> 
                                </ng-template>
                            </ng-container>

                        </ng-container>

                    </ngb-carousel>
                </div>
            </div>
            <div class="row SLV2-sm-gap" *ngIf="allBookMarksList?.length <= 0 && historyData?.length <= 0">
                    <div class="SLV2-section-head-section">
                        <h3 class="SLV2-section-heading">My Bookmarks</h3>
                        <button class="SLV2-viewall-link" (click) ="goTOBookMarks()" *ngIf="allBookMarksList?.length >=5">View all <img src="selflearnv2-ui/assets/img/self-learn-v2/right-blue-arrow.svg" /></button>
                    </div> 
                <div class="col">
                    <div class="SLV-no-content-box">
                        <img src="selflearnv2-ui/assets/img/self-learn-v2/no-bookmark-frame.svg" class="no-content-avatar" />
                        <h3 class="no-content-hdng">Uh uh! No bookmark found</h3>
                        <h4 class="no-content-text">Start exploring and save your <br> favorites for easy access.</h4>
                    </div>
                </div>
            </div>
        </div>


        <!-- <app-bookmark-video-card class="mobile-col-view" *ngIf="item.type == 'video' || item.type =='video_solution'" [videoData]="item" [cardTitle]="item.name"></app-bookmark-video-card>
        <app-bookmark-topic-summery-card class="mobile-col-view" *ngIf="item.type == 'flashcard'" [topicName]="item?.name" [flashcardData]="item" [allTopicsSummeryProgress]="allTopicsSummeryProgress"></app-bookmark-topic-summery-card>
        <app-memory-thumb-card class="mobile-col-view" *ngIf="item.type == 'memory_card'" [memoryData]="item" [cardTitle]="item.name"></app-memory-thumb-card>
        <app-questions-thumb-card class="mobile-col-view" *ngIf="item.type == 'practice_question'" [questionData]="item" [cardTitle]="item.name"></app-questions-thumb-card>  -->

        <!-- <div class="SLV2-section-wrap">
            <div class="row SLV2-sm-gap">
                <div class="col">
                    <div class="SLV2-section-head-section">
                        <h3 class="SLV2-section-heading">Liked videos</h3>
                        <button class="SLV2-viewall-link">View all <img src="selflearnv2-ui/assets/img/self-learn-v2/right-blue-arrow.svg" /></button>
                    </div>
                </div>
            </div>
            <div class="row SLV2-sm-gap">
                <div class="col">
                    <div class="SLV2-video-slider-area">
                        <carousel #myCarousel class="SLV2-video-carousel cell-padding" [height]="265" [margin]="6" [cellWidth]="300">
                            <div class="carousel-cell" *ngFor="let item of dummyLikedVideoData">
                                <app-video-card [videoData]="item" [cardTitle]="item.title"></app-video-card>
                            </div>
                        </carousel>
                    </div>
                </div>
            </div>
        </div> -->


        <!-- <div class="SLV2-section-wrap formula-banner-section">
            <div class="row SLV2-sm-gap">
                <div class="col">
                    <app-formula-sheets-banner-card></app-formula-sheets-banner-card>
                </div>
            </div>
        </div> -->


        <!-- <div class="SLV2-section-wrap">
            <div class="row SLV2-sm-gap">
                <div class="col">
                    <div class="SLV2-section-head-section">
                        <h3 class="SLV2-section-heading">History</h3>
                        <button class="SLV2-viewall-link">View all <img src="selflearnv2-ui/assets/img/self-learn-v2/right-blue-arrow.svg" /></button>
                    </div>
                </div>
            </div>
            <div class="row SLV2-sm-gap">
                <div class="col">
                    <div class="SLV-no-content-box">
                        <img src="selflearnv2-ui/assets/img/self-learn-v2/empty-avater.svg" class="no-content-avatar" />
                        <h3 class="no-content-hdng">Uh uh! No History found</h3>
                        <h4 class="no-content-text">History items will be added as you<br> continue using the app</h4>
                    </div>
                </div>
            </div>
        </div> -->
        <div class="SLV2-section-wrap SLV2-bookmark-slider-area">
            <div class="row SLV2-sm-gap" *ngIf="historyData?.length > 0">
                <div class="col">
                    <div class="SLV2-section-head-section">
                        <h3 class="SLV2-section-heading">History</h3>
                        <button class="SLV2-viewall-link" (click) =" goTOMyHistory()" *ngIf="historyData?.length >5">View all <img src="selflearnv2-ui/assets/img/self-learn-v2/right-blue-arrow.svg" /></button>
                    </div>
                </div>
            </div>
            <!-- <div class="row SLV2-sm-gap" *ngIf="historyData.length <= 0">
                <div class="col">
                    <div class="SLV-no-content-box">
                        <img src="selflearnv2-ui/assets/img/self-learn-v2/empty-avater.svg" class="no-content-avatar" />
                        <h3 class="no-content-hdng">Uh uh! No History found</h3>
                        <h4 class="no-content-text">History items will be added as you<br> continue using the app</h4>
                    </div>
                </div>
            </div> -->
            <div class="row SLV2-sm-gap" *ngIf="historyData?.length >0">
                <div class="col">
                    <ngb-carousel #carousel class="singleCarousel SLV2-bookmark-single-slider" [interval]="5000" [pauseOnHover]="pauseOnHover"
                        [pauseOnFocus]="pauseOnFocus">
                        <ng-container *ngFor="let item of historyData; let i = index">
            
                            <ng-container *ngIf="i<5">
                                {{item.assetType}}
                                <ng-template ngbSlide *ngIf="item.assetType == 'video' || item.assetType =='video_solution'">
                                    <app-bookmark-video-card class="mobile-col-view col-view"   [videoData]="item" [cardTitle]="item.assetName" [isFromMyLibrary]=true [isFromMyHistory]=true></app-bookmark-video-card>
                                </ng-template>
                                <ng-template ngbSlide *ngIf="item.assetType == 'flashcard'">
                                    <app-bookmark-topic-summery-card class="mobile-col-view col-view" [topicName]="item?.assetName" [flashcardData]="item"  [isFromMyLibrary]=true [isFromMyHistory]=true></app-bookmark-topic-summery-card>
                                </ng-template>
                                <ng-template ngbSlide *ngIf="item.assetType == 'memory_card'">
                                     <app-memory-thumb-card class="mobile-col-view  col-view" [memoryData]="item" [cardTitle]="item.name"  [isFromMyLibrary]=true [isFromMyHistory]=true></app-memory-thumb-card>
                                </ng-template> 
                                     <ng-template ngbSlide *ngIf="item.assetType == 'practice_question'">
                                    <app-questions-thumb-card class="mobile-col-view col-view"  [questionData]="item" [cardTitle]="item.name"  [isFromMyLibrary]=true [isFromMyHistory]=true></app-questions-thumb-card> 
                                </ng-template>
                            </ng-container>

                        </ng-container>

                    </ngb-carousel>
                </div>
            </div>
        </div>


    </div>
</div>